import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function heatmapCell(theme: Theme): ComponentStyle {
  return {
    componentName: 'heatmapCell',
    baseStyle: {
      width: theme.sizes['0'],
      height: theme.sizes['0'],
      borderRadius: '2px',
      position: 'relative',
      backgroundColor: theme.colors.muted10
    }
  };
}
